import { uniqBy } from 'lodash'
import * as yup from 'yup'
import { log } from './utils'

/**
 * @TODO
 * - All these header fields are managed in frontend right now, should we manage them from backend?
 */

// {
//     type: 'textarea',
//     name: 'comments_details',
//     label: 'Comments/Details',
//     required: false,
//     visibility: 'visible',
// },

export const isRequired = (field, slug) =>
    field.required === true && shouldShow(field, slug)

export const options = [
    {
        label: 'Property Address',
        required: true,
        message: 'Please fill Property Address',
        name: 'propaddres',
        type: 'combo',
        alias: [
            'Property address',
            'Property Address',
            'Property Addess',
            'property_address',
            'property address',
            'propaddress',
            'SiteAddr',
            'propaddres',
            'Full Site Address',
            'property address',
            'propertyaddressfull',
            'PROPERTY ADDRESS',
        ],
    },
    {
        label: 'Property City',
        message: 'Please fill Property City',
        required: true,
        type: 'combo',
        name: 'propcity',
        alias: [
            'Property city',
            'Property City',
            'property_city',
            'propcity',
            'SiteCity',
            'property_address_city',
            'Site Address City',
            'property_city',
            'property city',
            'propertyaddresscity',
            'PROPERTY CITY',
        ],
    },
    {
        label: 'Property State',
        required: false,
        message: 'Please fill Property State',
        name: 'propst',
        type: 'combo',
        alias: [
            'Property state',
            'Property St',
            'property_st',
            'Property State',
            'propst',
            'SiteState',
            'property_address_state',
            'Site Address State',
            'property_state',
            'property_st',
            'property state',
            'propertyaddressstate',
            'PROPERTY STATE',
        ],
    },
    {
        label: 'Property Zip',
        required: false,
        message: 'Please fill Property Zip',
        name: 'propzip',
        type: 'combo',
        alias: [
            'Property zip',
            'Property Zip',
            'property_zip',
            'propzip',
            'SiteZip',
            'property_address_zip',
            'Site Address Zip',
            'property_zip',
            'property zipcode',
            'property zip',
            'propertyaddresszip',
            'PROPERTY ZIP',
        ],
    },
    {
        label: 'First Name or Full Name',
        required: true,
        message: 'Please fill First Name or Full Name',
        name: 'first',
        type: 'combo',
        alias: [
            'First Name',
            "Owner's First Name",
            'first_name',
            'firstname',
            'first',
            'Owner1NameFirst',
            'OWNER 1 FIRST NAME',
            'owner_firstname',
            'owner first name',
            'first name',
            'Primary Contact First Name',
            'grantee1namefull',
            'FIRST NAME',
        ],
    },
    {
        label: 'Last Name',
        required: false,
        message: 'Please fill Last Name',
        name: 'last',
        type: 'combo',
        alias: [
            'Last Name',
            'last_name',
            'lastname',
            "Owner's Last Name",
            'last',
            'Owner1NameLast',
            'OWNER 1 LAST NAME',
            'owner_lastname',
            'owner last name',
            'last name',
            'Primary Contact Last Name',
            'LAST NAME',
        ],
    },
    {
        label: 'Mailing Address',
        required: true,
        message: 'Please fill Mailing Address',
        name: 'address',
        type: 'combo',
        alias: [
            'Mailing address',
            'Mailing Address',
            'address',
            'mailing_address',
            'mailing address',
            'mailaddress',
            'Mail Address',
            'MailAddr',
            'Mailing Addresses 1',
            'owner_address',
            'Mailing_Address',
            'mail_address',
            'Primary Contact Primary Mailing Address',
            'contactownermailaddressfull',
            'MAILING ADDRESS',
        ],
    },
    {
        name: 'mailing_address_2',
        message: 'Please fill Mailing Address 2',
        label: 'Mailing Suite/Apt (Optional)',
        required: false,
        type: 'combo',
        alias: [
            // 'mailing_address_2'
        ],
    },
    {
        label: 'Mailing City',
        required: true,
        message: 'Please fill Mailing City',
        name: 'city',
        type: 'combo',
        alias: [
            'Mailing city',
            'city',
            'Mailing City',
            'mailing_city',
            'mailcity',
            'Mail City',
            'MailCity',
            'MailingCity',
            'owner_city',
            'Mailing_City',
            'mail_city',
            'mailing city',
            'Primary Contact Primary Mailing City',
            'contactownermailaddresscity',
            'MAILING CITY',
        ],
    },
    {
        label: 'Mailing State',
        required: true,
        message: 'Please fill Mailing State',
        name: 'st',
        type: 'combo',
        alias: [
            'Mailing state',
            'Mailing St',
            'mailing_st',
            'mailst',
            'st',
            'state',
            'Mailing State',
            'Mail State',
            'MailState',
            'MailingState',
            'owner_state',
            'Mailing_State',
            'Mailing_St',
            'mail_state',
            'mailing state',
            'Primary Contact Primary Mailing State',
            'contactownermailaddressstate',
            'MAILING STATE',
        ],
    },
    {
        label: 'Mailing Zip',
        required: true,
        message: 'Please fill Mailing Zip',
        name: 'zip',
        type: 'combo',
        alias: [
            'Mailing zip',
            'Mail Zip',
            'zip',
            'MailZip',
            'Mailing Zip',
            'MailingZip',
            'owner_zip',
            'Mailing_Zip',
            'Mailing',
            'ZipCode',
            'Mailing_Zipcode',
            'mail_zip_code',
            'mailing zip',
            'Primary Contact Primary Mailing Zip',
            'contactownermailaddresszip',
            'MAILING ZIP',
        ],
    },
]

export const OptionalcontactInfoMailer = [
    {
        label: 'Email Address',
        required: false,
        message: 'Please fill Email Address',
        name: 'retemail',
        alias: [
            'retemail',
            'Email 1',
            'email_1',
            'email',
            'email address',
            'email address 1',
        ],
        manually: true,
        type: 'list',
    },
    {
        label: 'Website',
        message: 'Please fill Website',
        required: false,
        name: 'retwebsite',
        manually: true,
        alias: ['retwebsite'],
    },
]

export const contactInfoMailer = [
    {
        label: 'Signature',
        required: true,
        message: 'Please fill Signature',
        name: 'signature',
        type: 'list',
        manually: true,
        alias: ['signature'],
        // show: ['real-penned-letters', 'real-penned-postcards'],
    },
    {
        label: 'Phone Number',
        required: true,
        message: 'Please fill Phone Number',
        name: 'retphone',
        comboType: 'phone',
        maxLength: 16,
        type: {
            phone: ['real-penned-postcards'],
            default: 'list',
            // default is dropdown
        },
        alias: [
            'retphone',
            'Mobile Phone 1',
            'mobile_phone_1',
            'mobile',
            'cell',
            'cell phone',
            'cell phone 1',
            'mobile phone',
        ],
        manually: true,
    },
]

export const returnFields = [
    {
        label: 'Return Name',
        required: false,
        message: 'Please fill Return Name',
        name: 'retname',
        alias: ['retname'],
        type: {
            text: ['real-penned-letters', 'real-penned-postcards'],
            default: 'list',
            // default is dropdown
        },
        manually: true,
    },
    {
        label: 'Return Address',
        required: false,
        message: 'Please fill Return Address',
        name: 'retaddress',
        alias: ['retaddress'],
        type: {
            text: ['real-penned-letters', 'real-penned-postcards'],
            default: 'list',
            // default is dropdown
        },
        manually: true,
    },
    {
        label: 'Return City, State & Zip',
        required: false,
        message: 'Please fill Return City, State & Zip',
        name: 'retarea',
        alias: ['retarea'],
        type: {
            text: ['real-penned-letters', 'real-penned-postcards'],
            default: 'list',
            // default is dropdown
        },
        manually: true,
    },
]

const smartyStreetConditions = {
    propcity: {
        deps: ['propzip', 'propaddres'],
    },
    propst: {
        deps: ['propzip', 'propaddres'],
    },
    propzip: {
        deps: ['propst', 'propcity'],
    },
    city: {
        deps: ['zip', 'address'],
    },
    st: {
        deps: ['zip', 'address'],
    },
    zip: {
        deps: ['city', 'st'],
    },
}

const smartyStreetValidation = (name) => {
    /**
     * Logic for Property Address
     * https://www.notion.so/open-letter-marketing/Single-Product-Page-Notes-e2626364bffe4f17a35a90bb2a3d9e06#f72f989770e446e5b7e597d00a06df46
     * https://github.com/jquense/yup/issues/193
     * https://github.com/react-hook-form/resolvers/issues/43
     * */
    return yup
        .mixed()
        .test(
            'is-required',
            'Please fill ${path}, its required',
            (value, { parent }) =>
                value
                    ? true
                    : smartyStreetConditions[name].deps.every(
                          (dep) => parent[dep],
                      ),
        )
}

export const shouldShow = (item, slug) => {
    return item.show ? item.show.includes(slug) : true
}

export function mappingValidationRules({ options = [], currentStep, slug }) {
    let rulesObject = {}
    options.forEach((field) => {
        const { name } = field
        rulesObject[name] = smartyStreetConditions[name]
            ? smartyStreetValidation(name)
            : isRequired(field)
            ? yup.mixed().required(field.message).nullable()
            : yup.mixed().nullable()
    })

    // @TODO should we manage this some place else?
    if (currentStep > 1) {
        contactInfoMailer.forEach((field) => {
            const { name } = field
            if (isRequired(field, slug))
                rulesObject[name] = yup
                    .string()
                    .required(field.message)
                    .nullable()
        })
    }

    return yup.object().shape(rulesObject)
}

export const outputHeaders = [
    'propaddres',
    'propcity',
    'propst',
    'propzip',
    'first',
    'last',
    'address',
    'mailing_address_2',
    'city',
    'st',
    'zip',
    'retname',
    'retaddress',
    'retarea',
    'retphone',
    'retemail',
    'retwebsite',
    'signature',
    // 'order', // remove order
]
export const isValidAddress = (dpv_match_code) =>
    dpv_match_code && dpv_match_code !== 'N' && dpv_match_code !== null

const compareFunction = (item) => {
    // we see it as not duplicate if only item.propaddres is available
    if (item.propcity === '' && item.propst === '' && item.propzip === '')
        return Math.random()
    // old implementation
    return item.propaddres + item.propcity + item.propst + item.propzip
}
export const removePropertyDuplicates = (smartyJson) => {
    // remove blanks
    smartyJson = smartyJson.filter((item) => item.propaddres.length > 0)

    return uniqBy(smartyJson, compareFunction)
}

export const removeMailingDuplicates = (smartyJson) => {
    return uniqBy(smartyJson, (item) => item.address + item.city + item.st)
}

export const SameAsMailingAddressFields = ['propaddres']

export const SameAsMailiangAddresMatchingFields = {
    propaddres: 'address',
    propcity: 'city',
    propst: 'st',
    propzip: 'zip',
}

export const SameAsMailingAddressValue = '-Same As Mailing Address-'

export const handleValidationWhenSameAsApplied = (values) => {
    let draftValues = { ...values }
    const hasSameValue = Object.keys(values).some(
        (key) => values[key] === SameAsMailingAddressValue,
    )
    log('hasSameValue', hasSameValue)
    if (hasSameValue) {
        Object.keys(SameAsMailiangAddresMatchingFields).forEach((key) => {
            draftValues[key] = values[SameAsMailiangAddresMatchingFields[key]]
        })
    }
    log('draftValues', draftValues)
    return draftValues
}

export const predefinedMappingFields = [
    // '-Same As Mailing Adddress-',
]

export const postMapping = (item, idx) => {
    let modifiledItem = {
        count: idx + 1,
        ...item,
    }
    return modifiledItem
}
